<template>
  <div class="elegantList">
    <div class="container">
      <div class="flex" style="align-items: center;margin-bottom: 25px;padding-top: 25px;">
        <span style="font-size: 14px;">当前位置：</span>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item style="cursor: pointer;" :to="{ name: 'innovateService' }">创新服务</el-breadcrumb-item>
          <el-breadcrumb-item>企业风采</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="con-bottom">
        <div
          class="item"
          v-for="(item,index) in dataList"
          :key="index"
          @click="goToDetail(item.uuid)"
        >
          <div class="item-Bg" :style="{ backgroundImage: `url(${item.pic})` }"></div>
          <div class="item-title over-num-lines over-1-lines">{{item.title}}</div>
        </div>
      </div>
      <div style="text-align: center;padding: 30px 0;margin-top: 30px">
        <el-pagination
          @current-change="onChangeCurrent"
          :current-page="params.current"
          :page-size="params.pageSize"
          background
          layout="prev, pager, next"
          :total="params.total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getElegantList } from "../../utils/interface";
export default {
  data() {
    return {
      params: {
        current: 1,
        pageSize: 12,
        total: 0
      },
      dataList: []
    };
  },
  mounted() {
    this.getElegantList();
  },
  methods: {
    getElegantList() {
      getElegantList({
        current: this.params.current,
        pageSize: 12,
        status: 1
      }).then(res => {
        if (res.list.length) {
          this.dataList = res.list;
          this.params.total = res.total;
        } else {
          this.dataList = [];
          this.params.total = 0;
        }
      });
    },
    goToDetail(uuid) {
      let router = this.$router.resolve({
        path: "./elegantDetail",
        query: {
          uuid: uuid
        }
      });
      window.open(router.href, "_blank");
    },
    onChangeCurrent(e) {
      this.params.current = e;
      this.getElegantList();
    }
  }
};
</script>

<style lang="less" scoped>
.elegantList {
  background: #ffffff;
  //超出指定行换行
  .over-num-lines {
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }

  .over-1-lines {
    -webkit-line-clamp: 1;
  }
  .container {
    width: 1200px;
    margin: 0 auto;
    .con-bottom {
      display: flex;
      flex-flow: row wrap;
      justify-content: start;
      .item {
        width: 23%;
        height: 175px;
        margin: 0.5%;
        position: relative;
        cursor: pointer;
        display: flex;
        flex-flow: column nowrap;
        border: 1px solid #efefef;
        border-radius: 12px;
        .item-Bg {
          flex: 1;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-position: center center;
          border-top-left-radius: 12px;
          border-top-right-radius: 12px;
        }
        .item-title {
          width: 100%;
          height: 32px;
          line-height: 32px;
          padding: 0 8px;
          font-weight: bold;
          font-size: 15px;
          box-sizing: border-box;
          text-align: center;
        }
      }
    }
  }
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #2d50a1;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/innovateService/elegantList.vue